import { OutboundMetaWebService, TreeNode } from 'ws/OutboundMetaWebService';

export class TreeDataManager {
  webService: OutboundMetaWebService;
  setLoading: (loading: boolean) => void;
  constructor(
    webService: OutboundMetaWebService,
    setLoading: (loading: boolean) => void,
  ) {
    this.webService = webService;
    this.setLoading = setLoading;
  }

  private transformNodes(nodes: TreeNode[]): TreeNode[] {
    if (!nodes || nodes.length === 0) {
      return [];
    }
    // 資料轉換邏輯：將 API 回傳的資料轉換成帶 id 的格式
    return nodes.map((node) => ({
      id: (node.value || node.id).toString(), // 使用 value 作為 id，如果沒有 id，則使用 value，確保 id 是字符串類型
      value: node.value,
      label: node.label,
      children: node.children?.map((child) => ({
        id: (child.value || child.id).toString(), // 子節點也進行轉換
        value: child.value,
        label: child.label,
        children: child.children || [],
      })),
    }));
  }

  async fetchTree(parentId?: string): Promise<TreeNode[]> {
    this.setLoading(true);
    try {
      const nodes = await this.webService.getProductCategories(parentId);
      return this.transformNodes(nodes);
    } catch (error) {
      throw error;
    } finally {
      this.setLoading(false);
    }
  }

  // 新增一個方法，用於生成根節點
  async getDefaultRootNode(): Promise<TreeNode[]> {
    this.setLoading(true);
    try {
      const rootNode = await this.webService.getProductCategories();
      if (!rootNode || rootNode.length === 0) {
        return [];
      }
      return [
        {
          id: 'categoryRoot',
          value: 'categoryRoot',
          label: '品類',
          children: await this.transformNodes(rootNode),
        },
      ];
    } catch (error) {
      throw error;
    } finally {
      this.setLoading(false);
    }
  }
}
